import { Pipe, PipeTransform } from '@angular/core';
import { FileRecordDto } from '@careapp-group/ng-sdk-v2-new';
import { Store } from '@ngrx/store';
import { isAfter, parseISO } from 'date-fns';
import { distinct, filter, map } from 'rxjs/operators';
import { FilesSelectors } from '../../store/files/files-selectors';
import { requestDownloadUrl } from '../../store/files/files.actions';

@Pipe({
  name: 'filedownloadurl',
  pure: true,
})
export class FileDownloadUrlPipeV2 implements PipeTransform {
  constructor(private store: Store) {}

  public transform(object: Pick<FileRecordDto, 'variants' | 'id'>, size = 'sizeMedium') {
    if (!object) {
      return '';
    }
    const variant = object.variants?.find((v) => v.purpose === size);
    if (variant) {
      return this.getDownloadUrl(variant);
    }
    return this.getDownloadUrl(object);
  }

  getDownloadUrl(file?: { id: string }) {
    if (!!file.id) {
      this.store.dispatch(requestDownloadUrl({ id: file.id }));
      return this.store.select(FilesSelectors.getFilesState).pipe(
        map((filesState) => filesState.urls[file.id]),
        filter((url) => url && (!url.expiresAt || isAfter(parseISO(url.expiresAt), Date.now()))),
        map((url) => url.url),
        distinct()
      );
    }
    return null;
  }
}
